export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/uploads/') || url.startsWith('uploads/')) {
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;
    const host = API_URL.replace(/\/api$/, '');
    return `${host}${cleanUrl}`;
  }
  return url;
};
